import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            initOnRender: false,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            }
        ],

        searchFields: [
            {
                name: "occupationHealthPartnerId",
                label: "FEÜ partner",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllPartnersToSelect,
                    formatText: function (val) {
                        return val.name;
                    },
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "labTypeId",
                label: "Lelet típus",
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getOccupationHealthLabTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
           /* {
                name: "treatmentDateFrom",
                label: "Kezelés dátumától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "treatmentDateTo",
                label: "Kezelés dátumáig",
                formSize: 3,
                formType: "date"
            },*/
            {
                name: "dateOfExpirationFrom",
                label: "Lejárat dátumától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "dateOfExpirationTo",
                label: "Lejárat dátumáig",
                formSize: 3,
                formType: "date"
            },
            {
                name: "labCreatedOnFrom",
                label: "Létrehozás dátumától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "labCreatedOnTo",
                label: "Létrehozás dátumáig",
                formSize: 3,
                formType: "date"
            },
        ],

        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "occupationHealthPartner",
                label: "FEÜ Partner",
                visibility: true,
                sort: true
            },
            {
                name: "occupationHealthPartnerSite",
                label: "FEÜ Partner telephely",
                visibility: true,
                sort: true
            },
            {
                name: "occupationHealthSiteGroup",
                label: "Munkakör",
                visibility: true,
                sort: true
            },
            {
                name: "patient.name",
                label: "Páciens",
                visibility: true
            },
            {
                name: "doctorFullName",
                label: "Orvos",
                visibility: true,
                sort: true
            },
            {
                name: "labType",
                label: "Lelet típusa",
                visibility: true,
                sort: true
            },
            {
                name: "dateOfExpiration",
                label: "Lejárat dátuma",
                visibility: true,
                sort: true,
                slot_name: "productionTime_format"
            },
            {
                name: "labCreatedOn",
                label: "Létrehozás dátuma",
                visibility: true,
                sort: true,
                slot_name: "created_on_format",
            }
        ]
    }
}
